import Vue from 'vue'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'

Vue.use(Vuetify)

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: '#1DA7FC',
        secondary: '#ea2d2d',
        success: '#3dad21',
        error: '#f22803',
        accent: '#ed2748',
        blue: '#007aff',
        'gray-400': '#4a4a4a',
        'gray-700': '#9b9b9b',
        'gray-800': '#d8d8d8',
      },
    },
  },
  icons: {
    iconfont: 'md',
    values: {
      // checkboxOff: 'far fa-square',
      // checkboxOn: 'fas fa-check-square',
      // radioOn: '...',
      // radioOff: '...',
    },
  },
})
